import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
export function Hud({ visible = false, ...props }) {
    return _jsx(HudRoot, { ...props, "$visible": visible });
}
const HudRoot = styled.div `
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    transition: visibility 300ms 300ms, opacity 300ms 0s;

    ${({ $visible }) => $visible &&
    css `
            opacity: 1;
            pointer-events: all;
            visibility: visible;
            transition-delay: 0s;
        `}
`;
